// extracted by mini-css-extract-plugin
export var highlightFade = "_2f-4";
export var highlighted = "_2f-3";
export var table = "_2f-1";
export var tableContainer = "_2f-0";
export var totalsRow = "_2f-2";